import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { CalendarMonth as CalendarIcon } from '@mui/icons-material'
import { CalendarInputProps } from './CalendarInput.types'

export const CalendarInput = ({
  value,
  onChange,
  iconLabel = 'calender icon',
  className,
  disabled = false,
  closeOnDateSelection = true,
  format = 'dd.MM.yyyy',
  size,
  ...otherProps
}: CalendarInputProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        value={value}
        onChange={onChange}
        disabled={disabled}
        format={format}
        closeOnSelect={closeOnDateSelection}
        slots={{
          openPickerIcon: CalendarIcon,
        }}
        slotProps={{
          textField: {
            variant: 'outlined',
            size: size,
            sx: {
              width: '100%',
              borderRadius: '3px',
              '& .MuiInputBase-input': {
                paddingTop: size === 'small' ? '9px' : '15px',
                paddingBottom: size === 'small' ? '9px' : '14px',
              },
            },
            InputProps: {
              ...({ 'data-testid': 'calendar-input' } as any),
            },
            inputProps: {
              'aria-label': 'calendar-input',
            },
          },
          openPickerButton: {
            'aria-label': iconLabel,
            disableRipple: true,
          },
        }}
        {...otherProps}
      />
    </LocalizationProvider>
  )
}
